import { Component } from "@builder.io/sdk";

export const calendlyWidgetConfig: Component = {
  name: "Calendly Widget",
  inputs: [
    {
      name: "calendlyUrl",
      type: "string",
      required: true,
      helperText:
        "The Calendly link URL (e.g., https://calendly.com/your-username/meeting)",
      defaultValue:
        "https://calendly.com/kristinefacelo/facility-staffing-discovery-call-care-indeed",
    },
    {
      name: "redirectUrl",
      type: "string",
      helperText:
        "Fallback redirect URL if not provided via URL params (?redirectUrl=/thank-you or ?redirect=/thank-you). Widget will redirect here after scheduling.",
      defaultValue: "",
    },
    {
      name: "heading",
      type: "string",
      defaultValue: "Schedule Your Consultation",
      helperText: "Main heading text displayed at the top",
    },
    {
      name: "subheading",
      type: "string",
      defaultValue: "We're here to help you find the perfect care solution",
      helperText: "Subheading text displayed below the main heading",
    },
    {
      name: "reminder",
      type: "string",
      defaultValue: "Please select a date and time using the calendar below.",
      helperText: "Reminder text displayed above the calendar widget",
    },
    {
      name: "phoneNumber",
      type: "string",
      defaultValue: "(844) 248-4102",
      helperText:
        "Phone number to display in the footer note for urgent concerns",
    },
    {
      name: "showStartOverButton",
      type: "boolean",
      defaultValue: false,
      helperText: "Show a 'Start over?' button below the calendar",
    },
    {
      name: "passEventDataToRedirect",
      type: "boolean",
      defaultValue: true,
      helperText:
        "Automatically pass scheduled event data (date, time, type) to the redirect URL via search params",
    },
  ],
};
